var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detaioBread"},[_c('div',{staticClass:"detaioBread_"},[_c('em',{on:{"click":_vm.goback}},[_vm._v("智慧后勤建设")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"}),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.breadName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3ef09f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailBread.vue
// module id = null
// module chunks = 